const hostName = window.location.hostname
// export const API_URL = hostName=="emp.jcsoftwaresolution.in"?"https://api.jcsoftwaresolution.in/":'http://endpoint.jcsoftwaresolution.com:6058/';
// export const API_URL = "http://195.35.8.196:6002/";
//export const API_URL = "http://195.35.8.196:6099/"
export const API_URL = "https://api.jcsoftwaresolution.in/"
